import { Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProfilePage } from './pages/ProfilePage';
import { CreateLeaguePage } from './pages/leagues/CreateLeaguePage';
import { LeagueDetailPage } from './pages/leagues/LeagueDetailPage';
import { JoinPage } from './pages/leagues/JoinPage';
import { EnterCodePage } from './pages/leagues/EnterCodePage';
import { MatchdayListPage } from './pages/leagues/MatchdayListPage';
import { MatchdayDetailPage } from './pages/leagues/MatchdayDetailPage';
import { PredictionPage } from './pages/leagues/PredictionPage';
import { StandingsPage } from './pages/leagues/StandingsPage';
import { HistoryPage } from './pages/leagues/HistoryPage';
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';
import { AdminLeaguesPage } from './pages/admin/AdminLeaguesPage';
import { AdminDataPage } from './pages/admin/AdminDataPage';
import { AdminAuditPage } from './pages/admin/AdminAuditPage';
import { RulesetPage } from './pages/leagues/RulesetPage';
import { QuizPage } from './pages/leagues/QuizPage';
import { AdmissionAdminPage } from './pages/leagues/AdmissionAdminPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { PrivacyPage } from './pages/legal/PrivacyPage';
import { CookiePage } from './pages/legal/CookiePage';
import { InstallPage } from './pages/InstallPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { RequireAuth } from './features/auth/RequireAuth';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/accedi" element={<LoginPage />} />
      <Route path="/registrati" element={<RegisterPage />} />
      <Route path="/verifica-email" element={<VerifyEmailPage />} />
      <Route path="/password-dimenticata" element={<ForgotPasswordPage />} />
      <Route path="/reimposta-password" element={<ResetPasswordPage />} />

      {/* Invito: accessibile anche senza login */}
      <Route path="/entra/:code" element={<JoinPage />} />

      {/* Pagine pubbliche */}
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/cookie" element={<CookiePage />} />
      <Route path="/installa" element={<InstallPage />} />

      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/profilo"
        element={
          <RequireAuth>
            <ProfilePage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/nuova"
        element={
          <RequireAuth>
            <CreateLeaguePage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id"
        element={
          <RequireAuth>
            <LeagueDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id/giornate"
        element={
          <RequireAuth>
            <MatchdayListPage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id/giornate/:mdId"
        element={
          <RequireAuth>
            <MatchdayDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id/giornate/:mdId/pronostici"
        element={
          <RequireAuth>
            <PredictionPage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id/classifica"
        element={
          <RequireAuth>
            <StandingsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id/storico"
        element={
          <RequireAuth>
            <HistoryPage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id/regolamento"
        element={
          <RequireAuth>
            <RulesetPage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id/quiz"
        element={
          <RequireAuth>
            <QuizPage />
          </RequireAuth>
        }
      />
      <Route
        path="/leghe/:id/ammissione"
        element={
          <RequireAuth>
            <AdmissionAdminPage />
          </RequireAuth>
        }
      />
      <Route
        path="/notifiche"
        element={
          <RequireAuth>
            <NotificationsPage />
          </RequireAuth>
        }
      />

      {/* Pannello Super Admin (guard dentro AdminLayout) */}
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminDashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/utenti"
        element={
          <RequireAuth>
            <AdminUsersPage />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/leghe"
        element={
          <RequireAuth>
            <AdminLeaguesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/dati"
        element={
          <RequireAuth>
            <AdminDataPage />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/audit"
        element={
          <RequireAuth>
            <AdminAuditPage />
          </RequireAuth>
        }
      />
      <Route
        path="/entra-con-codice"
        element={
          <RequireAuth>
            <EnterCodePage />
          </RequireAuth>
        }
      />

      {/* Qualsiasi altra URL: mai una pagina bianca */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
